import { render, staticRenderFns } from "./ChoiceRejectPayment.vue?vue&type=template&id=0e862480&"
import script from "./ChoiceRejectPayment.vue?vue&type=script&lang=js&"
export * from "./ChoiceRejectPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports